import { Container } from '@mui/material';
import { Outlet } from '@remix-run/react';

export default function ShowcaseLayout() {
  return (
    <Container maxWidth="xl">
      <Outlet />
    </Container>
  );
}
